"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const OptionsButton_1 = __importDefault(require("../../atoms/OptionsButton"));
const DrawOptions_1 = __importDefault(require("../DrawOptions"));
const bridge_1 = require("@completeanatomy/bridge");
const colors_1 = require("../../utils/colors");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const useSketchOptions_1 = require("../../hooks/useSketchOptions");
const providers_1 = require("../../providers");
const PEN_COLORS = [
    ui_1.colorPalette.black,
    ui_1.colorPalette.vividCerulean,
    ui_1.colorPalette.lightSeaGreen,
    ui_1.colorPalette.halloweenOrange,
    ui_1.colorPalette.pinkBite,
    ui_1.colorPalette.kenMastersRed,
];
const PEN_SIZES = [
    bridge_schema_1.PenSizeIndex.XLarge,
    bridge_schema_1.PenSizeIndex.Large,
    bridge_schema_1.PenSizeIndex.Medium,
    bridge_schema_1.PenSizeIndex.Small,
];
function ToolsSketchOptionsPanel({ className, onToggle, color = '', size, selectedID, setSelectedColor, setSelectedSize, }) {
    const [isOptionsActive, setOptionsActive] = (0, react_1.useState)(false);
    const bridge = (0, bridge_1.useBridge)();
    const containerRef = (0, react_1.useRef)(null);
    const tools = (0, providers_1.useToolsService)();
    const [currentColor, setCurrentColor] = (0, react_1.useState)(color);
    const [currentSize, setCurrentSize] = (0, react_1.useState)(size);
    const sketchManager = tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager();
    const { color: currentSketchColor, size: currentSketchSize } = (0, useSketchOptions_1.useSketchOptions)();
    const onChangeColor = (value) => {
        const { r, g, b } = (0, colors_1.hexToRgbComponents)(value);
        const rgbColorString = `${r},${g},${b}`;
        sketchManager === null || sketchManager === void 0 ? void 0 : sketchManager.updateSketchOptions({
            color: rgbColorString,
            size: currentSketchSize,
        });
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateSketch({ color: rgbColorString });
        setCurrentColor(rgbColorString);
        setSelectedColor(rgbColorString);
    };
    const onChangeSize = (value) => {
        sketchManager === null || sketchManager === void 0 ? void 0 : sketchManager.updateSketchOptions({
            color: currentSketchColor,
            size: value,
        });
        bridge === null || bridge === void 0 ? void 0 : bridge.toolUpdateSketch({ size: value });
        setCurrentSize(value);
        setSelectedSize(value);
    };
    const onClickHandler = (event) => {
        event.stopPropagation();
    };
    const onErase = () => {
        if (selectedID) {
            tools === null || tools === void 0 ? void 0 : tools.getStickiesToolManager().updateSticky({
                identifier: selectedID,
                curves: [],
            });
        }
    };
    const onToggleOptions = (isActive) => {
        setOptionsActive(isActive);
        onToggle(isActive);
    };
    const events = (0, ui_1.getPointersEvents)();
    (0, ui_1.useEvent)(containerRef, events.down, onClickHandler);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_1.Overlay, { shown: isOptionsActive, zIndex: 1, "data-e2e": 'ToolsSketchOptionsPanel_Overlay' }), (0, jsx_runtime_1.jsxs)(Container, { ref: containerRef, className: className, "data-e2e": 'ToolsSketchOptionsPanel_Container', children: [!isOptionsActive && ((0, jsx_runtime_1.jsx)(EraseButton, { onClick: onErase, "data-e2e": 'ToolsSketchOptionsPanel_EraseButton', children: (0, jsx_runtime_1.jsx)(EraseButtonIcon, { name: ui_1.Icons.Tools_Erase, "data-e2e": 'ToolsSketchOptionsPanel_EraseButtonIcon' }) })), (0, jsx_runtime_1.jsx)(DrawOptions_1.default, { colors: PEN_COLORS, sizes: PEN_SIZES, color: (0, colors_1.rgbComponentsToHex)(currentColor), size: currentSize, withOpacity: false, onChangeColor: onChangeColor, onChangeSize: onChangeSize, onToggle: onToggleOptions, "data-e2e": 'ToolsSketchOptionsPanel_ToolsDrawOptionsPanel' })] })] }));
}
exports.default = ToolsSketchOptionsPanel;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
`;
const EraseButton = (0, styled_components_1.default)(OptionsButton_1.default) `
  z-index: 1; /* place button over draw options panel */

  margin: 0 20px 0 0;
`;
const EraseButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 30px;
  height: 30px;
`;
